<script setup lang="ts">
import { useI18n } from "vue-i18n";
import DatePicker from "primevue/datepicker";
import TooltipButton from "../../common/TooltipButton.vue";

const { t } = useI18n();

/**
 * Optional point in time (date and time) at which the direct link is deleted automatically, e.g. an
 * hour after an internal webinar ends, so the link cannot be passed on afterwards.
 * @property {string} inputId - Stable id of the date picker input (Cypress relies on it).
 */
defineProps({
    inputId: {
        type: String,
        required: true,
    },
});

const expiresAt = defineModel<Date | undefined>();

// A past expiry would delete the link right away, so only future points in time can be picked.
const minDate = new Date();
</script>

<template>
    <div>
        <label :for="inputId" class="text-sm font-bold block mb-2">
            {{ t("project-configuration.directLink.expiryLabel") }}
        </label>
        <div class="flex items-center">
            <DatePicker
                v-model="expiresAt"
                :input-id="inputId"
                :placeholder="t('project-configuration.directLink.expiryPlaceholder')"
                class="w-full"
                :date-format="t('formats.datePicker')"
                :min-date="minDate"
                show-time
                hour-format="24"
                show-icon
                show-button-bar
            />
            <TooltipButton :content="t('project-configuration.directLink.expiryTooltip')" background-color="white" />
        </div>
    </div>
</template>
